import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-plate-details',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './plate-details.component.html',
  styleUrls: ['./plate-details.component.scss']
})
export class PlateDetailsComponent implements OnInit {
  details: any = {};

  // Helper to store display data cleanly
  displayData: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<PlateDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data && this.data.plateDetailsData) {
      this.details = this.data.plateDetailsData;
      this.buildDisplayData();
    }
  }

  buildDisplayData() {
    // Mapping JSON fields to UI requirements
    this.displayData = [
      { label: 'Application', value: this.details.application?.name },
      { label: 'Site', value: this.details.site?.name },
      { label: 'Motor Name', value: this.details.name }, // "name" from root body
      {
        label: 'Frame',
        value: this.formatValueWithUnit(this.details.frame, this.details.frame_unit)
      },
      { label: 'Insulation Class', value: this.details.insulation_class },
      { label: 'Duty', value: this.details.duty },
      {
        label: 'Rated Ambient Temperature',
        value: this.formatValueWithUnit(this.details.rated_ambient_temprature, this.details.rated_ambient_temprature_unit)
      },
      { label: 'Motor Serial #', value: this.details.motor_serial_no },
      {
        label: 'Rated Power',
        value: this.formatValueWithUnit(this.details.rated_power, this.details.rated_power_unit)
      },
      { label: 'Rated RPM', value: this.details.rated_rpm },
      { label: 'Rated Voltage', value: this.details.rated_voltage },
      { label: 'MAC Address', value: this.details.mac_address },
      { label: 'Line Frequency', value: this.details.line_frequency },
      { label: 'Power Factor', value: this.details.power_factor }
    ];
  }

  // Helper to handle nulls and units (e.g., "12 L" or "--")
  formatValueWithUnit(val: any, unit: any): string {
    if (val === null || val === undefined || val === '') return '--';
    return unit ? `${val} ${unit}` : `${val}`;
  }
}